module.exports = __webpack_public_path__ + "static/media/x_icon.e094d34f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x_icon.svg
// module id = 140
// module chunks = 0